import React from 'react'
import PropTypes from 'prop-types'
import './ImpersonationNotification.css'

const ImpersonationNotification = ({ impersonation }) => {
  if (!impersonation || !impersonation.is_impersonating) {
    return null
  }

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString()
  }

  return (
    <div className="ImpersonationNotification">
      <div className="ImpersonationNotification__banner">
        <span className="ImpersonationNotification__icon">👁️</span>
        <span className="ImpersonationNotification__text">
          You are currently being impersonated by <strong>{impersonation.impersonator.username}</strong>
        </span>
        <span className="ImpersonationNotification__time">
          Started: {formatTime(impersonation.started_at)}
        </span>
      </div>
    </div>
  )
}

ImpersonationNotification.propTypes = {
  impersonation: PropTypes.shape({
    is_impersonating: PropTypes.bool,
    impersonator: PropTypes.shape({
      username: PropTypes.string.isRequired
    }),
    started_at: PropTypes.string
  })
}

export default ImpersonationNotification